module.exports = __webpack_public_path__ + "a.no1.a77587ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/a.no1.jpg
// module id = y4ho
// module chunks = 0